function MonthlyExpenditureSummary() {
  return (
    <div>
      <h2>Monthly Expenditure Summary</h2>
      <p>Your complete information comes here.</p>
    </div>
  );
}

export default MonthlyExpenditureSummary;